import React from 'react'
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { ReactComponent as Fb } from "../../../assets/svg/fbobs.svg";
import { ReactComponent as Lin } from "../../../assets/svg/linobs.svg";

const DialogComp = ({currentObs,open,setOpen}) => {
    

  

  const handleClose = () => {
    setOpen(false);
  };
  return (
    <div>
  <Dialog
    open={open}
    onClose={handleClose}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
  >
    
    <DialogContent>
      <div className='flex justify-evenly'>
        <img alt="some img" src={`https://cdn.sanity.io/images/xazjl9sh/production/${currentObs.imgPath.slice(6, -4) + '.' + currentObs.imgPath.slice(-3)}`} className=' max-w-[380px] max-h-[250px]' />
        <div className='col-start-2 col-end-6 grid gap-16'>
          <div className=''><h1 className='text-3xl font-semibold text-[#006DC4]'>{currentObs.name}</h1>
                <h2 className='text-2xl font-semibold text-[#54B3FF]'>{currentObs.role}</h2>

          </div>
          <div className='flex space-x-4'>
            <p className='gabriel text-[#484848]'>Suivez sur</p>
            <a href={currentObs.face}>
              <Fb />
            </a>
            <a href={currentObs.lin}>
            <Lin />

            </a>
          </div>
        </div>
      </div>
      <div className='p-4'>
        <p className='text-sm text-[#5A5A5A] max-h-[300px] overflow-y-scroll'>{currentObs.bio}</p>
      </div>
    </DialogContent>
  </Dialog></div>
  )
}

export default DialogComp